/* eslint-disable react/prop-types */
import React from 'react';
import { Box, Typography } from '@mui/material';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { STATUS_HEX, formatAppointmentNo, resolvePatientName } from '../constants';

// Compact "who's IN right now, who's NEXT" strip for one doctor's today
// queue. inAppointment/nextAppointment come from getQueueSynopsis().
export default function DoctorQueueSynopsis({ inAppointment, nextAppointment }) {
  if (!inAppointment && !nextAppointment) {
    return (
      <Typography sx={{ fontSize: '0.72rem', color: '#b0bac2', fontStyle: 'italic' }}>
        No active queue today
      </Typography>
    );
  }

  return (
    <Box display="flex" alignItems="center" flexWrap="wrap" gap={1.5}>
      {inAppointment && (
        <Box
          display="flex"
          alignItems="center"
          gap={0.6}
          sx={{
            px: 1.1,
            py: 0.4,
            borderRadius: 20,
            bgcolor: `${STATUS_HEX[inAppointment.status]}18`,
            border: `1px solid ${STATUS_HEX[inAppointment.status]}`,
          }}
        >
          <PersonPinIcon sx={{ fontSize: 15, color: STATUS_HEX[inAppointment.status] }} />
          <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, color: STATUS_HEX[inAppointment.status] }}>
            IN · #{inAppointment.serial_no} {resolvePatientName(inAppointment, inAppointment.irm_contacts_id)}
          </Typography>
        </Box>
      )}
      {nextAppointment && (
        <Box
          display="flex"
          alignItems="center"
          gap={0.6}
          sx={{
            px: 1.1,
            py: 0.4,
            borderRadius: 20,
            bgcolor: '#eef2f5',
            border: '1px solid #d5dde2',
          }}
        >
          <NavigateNextIcon sx={{ fontSize: 15, color: '#607d8b' }} />
          <Typography sx={{ fontSize: '0.68rem', fontWeight: 700, color: '#607d8b' }}>
            NEXT · #{nextAppointment.serial_no} {resolvePatientName(nextAppointment, nextAppointment.irm_contacts_id)}
          </Typography>
        </Box>
      )}
      {!nextAppointment && inAppointment && (
        <Typography sx={{ fontSize: '0.68rem', color: '#b0bac2' }}>
          ({formatAppointmentNo(inAppointment)} is the last in queue)
        </Typography>
      )}
    </Box>
  );
}
